module.exports = __webpack_public_path__ + "static/media/logo-generalitat.ea78e53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-generalitat.png
// module id = 119
// module chunks = 0